import React from 'react'
import { View, TouchableOpacity } from 'react-native'
import TypeWriter from 'react-native-typewriter'
import PropTypes from 'prop-types'
import { Txt, Icon } from '../../../components'
import { useTheme } from '../../../theming/ThemeProvider'
import { useCarouselItemStyles } from './styles'

const CarouselItem = ({ item }) => {
  const { title, keywords, link, icon, titleStyle } = item
  const { theme } = useTheme()
  const styles = useCarouselItemStyles(theme)

  const redirect = () => window.open(link, '_blank')
  return (
    <View>
      {icon ? (
        <Icon
          name={icon}
          height={60}
          width={120}
          fill={theme.WHITE_TEXT}
        />
      ) : (
        <Txt
          text='About Capacity'
          color='WHITE_TEXT'
          identity='h4'
        />
      )}
      <TypeWriter
        typing={1}
        style={{
          color: theme.WHITE_TEXT,
          flexShrink: 1,
          ...titleStyle
        }}
        maxDelay={50}
      >
        {title}
      </TypeWriter>
      <View style={styles.keywords}>
        {Boolean(keywords.length) && (
          keywords.map((keyword, key) => (
            <View key={key} style={styles.keyword}>
              <Txt
                text={keyword}
                color='LOCHMARA'
                identity='body2Bold'
              />
              {Boolean(key < keywords.length - 1) && (
                <View style={styles.separator} />
              )}
            </View>
          ))
        )}
      </View>
      {Boolean(link) && (
        <TouchableOpacity onPress={redirect}>
          <Txt
            text='View full article here'
            color='WHITE_TEXT'
            identity='body2Bold'
          />
        </TouchableOpacity>
      )}
    </View>
  )
}

CarouselItem.propTypes = {
  item: PropTypes.object
}

export default CarouselItem
